import {
  dimensionFromFileName,
  IDocumentMediaPreviewData,
  MESSAGE_CONTENT_TYPE,
} from "@home-health-notify/domain";
import { Box } from "@mui/material";
import React, { useState } from "react";
import { FreeMode, Navigation, Thumbs } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import DisplayAudio from "../../common/DisplayAudio";
import DisplayImage from "../../common/DisplayImage";
import DisplayVideo from "../../common/DisplayVideo";

const getScaledDimensions = (mediaItem: IDocumentMediaPreviewData) => {
  const isImage = mediaItem.mediaType === MESSAGE_CONTENT_TYPE.IMAGE;
  const isVideo = mediaItem.mediaType === MESSAGE_CONTENT_TYPE.VIDEO;
  const url = isImage
    ? mediaItem.media[0].url
    : isVideo
      ? mediaItem.media[0].thumbnail
      : null;

  if (!url) return;
  const dimensions = dimensionFromFileName(url);

  if (dimensions) {
    const { width, height } = dimensions;
    const maxWidth = window.innerWidth * 0.9;
    const maxHeight = window.innerHeight * 0.8;

    let scaledWidth = width;
    let scaledHeight = height;

    // Scale down if larger than screen
    if (width > maxWidth || height > maxHeight) {
      const widthRatio = maxWidth / width;
      const heightRatio = maxHeight / height;
      const scale = Math.min(widthRatio, heightRatio);

      scaledWidth = width * scale;
      scaledHeight = height * scale;
    }

    return { width: scaledWidth, height: scaledHeight };
  }
};

const MediaPreview = ({
  mediaList,
  thumbsSwiper,
  findMediaMessage,
  initialSlideIndex = 0,
  onSetMediaUrl,
}: {
  mediaList: IDocumentMediaPreviewData[];
  thumbsSwiper: any;
  findMediaMessage: (data: any) => void;
  initialSlideIndex?: number;
  onSetMediaUrl: (url: string) => void;
}) => {
  const [activeIndex, setActiveIndex] = useState(initialSlideIndex);

  const handleSlideChange = (swiper: any) => {
    setActiveIndex(swiper.activeIndex);
    findMediaMessage(swiper);
  };

  return (
    <Swiper
      spaceBetween={10}
      navigation={true}
      thumbs={{ swiper: thumbsSwiper }}
      modules={[FreeMode, Navigation, Thumbs]}
      onSlideChange={handleSlideChange}
      className="main-swiper"
      initialSlide={initialSlideIndex}
    >
      {mediaList.map((mediaItem, index) => {
        const scaledDimensions = getScaledDimensions(mediaItem);
        const isActiveSlide = index === activeIndex;
        return (
          <Box key={mediaItem.id + "message-slide"}>
            {mediaItem.mediaType === MESSAGE_CONTENT_TYPE.IMAGE && (
              <SwiperSlide key={mediaItem.id + "image-slide"}>
                <DisplayImage
                  url={mediaItem.media[0].url}
                  alt={mediaItem.title || mediaItem.mediaType}
                  style={{ objectFit: "contain" }}
                  fullSizeLoader={false}
                  enableZoom
                  containerStyle={scaledDimensions}
                  onSetMediaUrl={isActiveSlide ? onSetMediaUrl : undefined}
                />
              </SwiperSlide>
            )}
            {mediaItem.mediaType === MESSAGE_CONTENT_TYPE.VOICE && (
              <SwiperSlide key={mediaItem.id + "audio-slide"}>
                <DisplayAudio
                  url={mediaItem.media[0].url}
                  onSetMediaUrl={isActiveSlide ? onSetMediaUrl : undefined}
                />
              </SwiperSlide>
            )}
            {mediaItem.mediaType === MESSAGE_CONTENT_TYPE.VIDEO && (
              <SwiperSlide key={mediaItem.id + "video-slide"}>
                <DisplayVideo
                  url={mediaItem.media[0].url}
                  containerStyle={scaledDimensions}
                  onSetMediaUrl={isActiveSlide ? onSetMediaUrl : undefined}
                />
              </SwiperSlide>
            )}
          </Box>
        );
      })}
    </Swiper>
  );
};
export default MediaPreview;
